import React from 'react' ; 
import styles from './HorLine.css' ; 

const horLine = () => {
    return (
        <div className={styles.HorLine}>
        </div>
    )
}

export default horLine ; 
   
